import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import { BRAND, PRODUCTS } from "@/data/content";

const ease = [0.22, 1, 0.36, 1];

export default function ThankYou() {
  const { state } = useLocation();
  const name = state?.name || "";
  const plan = state?.plan || "";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main
      data-testid="thankyou-page"
      className="relative min-h-screen bg-brand text-white overflow-hidden flex items-center"
    >
      {/* producto en spotlight */}
      <motion.img
        src={PRODUCTS.pack3}
        alt=""
        aria-hidden
        initial={{ opacity: 0, scale: 1.1 }}
        animate={{ opacity: 0.35, scale: 1 }}
        transition={{ duration: 1.6, ease }}
        className="pointer-events-none absolute -right-32 top-1/2 -translate-y-1/2 w-[720px] max-w-none object-cover rounded-full blur-[2px]"
      />

      <div className="relative max-w-[900px] mx-auto px-6 md:px-10 py-24">
        <motion.div
          initial={{ scale: 0, rotate: -20 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 200, damping: 14, delay: 0.2 }}
        >
          <CheckCircle2 size={64} className="text-accent mb-8" />
        </motion.div>

        <div className="eyebrow text-accent mb-5">Pedido confirmado</div>

        <h1 className="font-serif font-light leading-[0.92] tracking-tight text-5xl sm:text-6xl lg:text-7xl">
          <span className="line-mask">
            <motion.span
              className="block"
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 1, ease, delay: 0.3 }}
            >
              ¡Gracias{name ? `, ${name.split(" ")[0]}` : ""}!
            </motion.span>
          </span>
          <span className="line-mask">
            <motion.span
              className="block italic text-brand-soft"
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 1, ease, delay: 0.45 }}
            >
              tu pedido está en camino
            </motion.span>
          </span>
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease, delay: 0.7 }}
          className="mt-10 max-w-lg"
        >
          {plan && (
            <div
              data-testid="thankyou-plan"
              className="inline-block rounded-full border border-white/25 bg-white/10 px-6 py-3 text-sm mb-6"
            >
              Tu oferta: <span className="text-accent font-medium">{plan}</span>
            </div>
          )}
          <p className="text-white/70 text-base md:text-lg leading-relaxed">
            Hemos recibido todos tus datos. Nuestro equipo de {BRAND} te
            contactará muy pronto para confirmar la entrega. Recuerda que
            también puedes escribirnos por WhatsApp si tienes preguntas.
          </p>

          <Link
            to="/"
            data-testid="thankyou-back"
            className="group mt-10 inline-flex items-center gap-3 rounded-full bg-accent text-white pl-7 pr-3 py-3.5 text-sm hover:bg-white hover:text-brand transition-colors duration-300"
          >
            Volver al inicio
            <span className="grid place-items-center h-9 w-9 rounded-full bg-white/20 group-hover:bg-brand/10">
              <ArrowLeft size={18} className="group-hover:-translate-x-0.5 transition-transform" />
            </span>
          </Link>
        </motion.div>
      </div>
    </main>
  );
}
